export const validateProviderName =
  ({ inputFields, editingIndex, tenantSubDomain }) =>
  (v) => {
    if (!v) return true;

    if (!/^[^_\p{Z}]{3,}$/u.test(v)) {
      return 'Must be at least 3 characters long and contain only letters, numbers, and special characters except for spaces and underscores.';
    }

    if (v.length > 32) {
      return 'Provider name cannot be more than 32 characters';
    }

    const duplicate = inputFields.some(
      (item, i) =>
        i !== editingIndex && item.tenantSubDomain === tenantSubDomain && item.providerName === v
    );
    if (duplicate) return 'Provider name already exists for this tenant';

    return true;
  };
